import MenusWidget from './MenusWidget';

export default MenusWidget;
